/**
 * Primary intake actions that stretch full width below the `sm` breakpoint
 * (640px) and shrink to their content from `sm` up.
 *
 * `max-sm:min-h-11` is a 44px tap height. It applies only under 640px, so the
 * large button's fixed `h-10` (40px) is unchanged on desktop. There is no
 * `flex-1`: in a column flex container that basis collapses the button height.
 */
export const intakeStackedPrimaryCtaClassName =
  "w-full max-sm:min-h-11 sm:w-auto";

/**
 * Primary intake actions that stay full width at every breakpoint.
 * The 44px minimum still applies only under 640px.
 */
export const intakeFullWidthPrimaryCtaClassName = "w-full max-sm:min-h-11";
